import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class MetaService {
  public constructor(
    private readonly title: Title,
    private readonly tranlation: TranslocoService,
  ) {}

  public updateTitle(title: string, addBranding = true): void {
    const branding = addBranding ? ` | ${this.tranlation.translate('dashboard.brand')}` : '';
    this.title.setTitle(`${title}${branding}`);
  }
}
